import React, { useEffect, useState } from 'react';
import api from '../api'; // <--- Double check your path matches your file structure

const SupportTickets = ({ isStaff }) => {
    const [tickets, setTickets] = useState([]);
    const [loading, setLoading] = useState(true);
    
    // Form State (Contractors only)
    const [newTicket, setNewTicket] = useState({
        request_type: 'LIFT_SHIFT',
        description: '',
        location: '',
        desired_date: ''
    });

    const fetchTickets = async () => {
        try {
            const res = await api.get('support/');
            setTickets(res.data);
            setLoading(false);
        } catch (err) {
            console.error("Error loading tickets", err);
        }
    };

    useEffect(() => { fetchTickets(); }, []);

    // --- CONTRACTOR ACTION: Submit New Ticket ---
    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            await api.post('support/', newTicket);
            alert("Support Request Submitted!");
            setNewTicket({ request_type: 'LIFT_SHIFT', description: '', location: '', desired_date: '' });
            fetchTickets();
        } catch (err) {
            alert("Error submitting ticket: " + JSON.stringify(err.response?.data));
        }
    };

    // --- STAFF ACTION: Update Status ---
    const handleStatusUpdate = async (id, newStatus) => {
        try {
            await api.patch(`support/${id}/`, { status: newStatus });
            fetchTickets(); // Refresh list
        } catch (err) {
            alert("Error updating status");
        }
    };

    return (
        <div className="animate-fade-in">
            {/* --- HEADER --- */}
            <div style={{display:'flex', justifyContent:'space-between', alignItems:'center', marginBottom:'20px'}}>
                <h2 style={{color: '#f472b6', margin: 0}}>🔧 Operational Support</h2>
                {isStaff && <span className="status-badge status-APPROVED">Staff Mode</span>}
            </div>

            <div style={{display: 'grid', gridTemplateColumns: isStaff ? '1fr' : '1fr 350px', gap: '20px'}}>
                
                {/* --- LEFT: TICKET LIST --- */}
                <div className="card">
                    <h3 style={{marginTop:0, color: '#e2e8f0'}}>Active Requests</h3>
                    {tickets.length === 0 ? <p style={{color:'#94a3b8'}}>No active support requests.</p> : (
                        <div style={{display:'flex', flexDirection:'column', gap:'10px'}}>
                            {tickets.map(t => (
                                <div key={t.id} style={{
                                    background: '#1e293b', 
                                    padding: '15px', 
                                    borderRadius: '8px', 
                                    borderLeft: `4px solid ${t.status === 'PENDING' ? '#facc15' : t.status === 'APPROVED' ? '#3b82f6' : '#4ade80'}`
                                }}>
                                    <div style={{display:'flex', justifyContent:'space-between'}}>
                                        <strong style={{color:'white'}}>{t.request_type.replace('_', ' ')}</strong>
                                        <span className={`status-badge status-${t.status}`}>{t.status}</span>
                                    </div>
                                    <div style={{fontSize:'0.9rem', color:'#cbd5e1', margin:'5px 0'}}>"{t.description}"</div>
                                    
                                    {/* --- UPDATED SECTION: SHOW NAMES INSTEAD OF IDs --- */}
                                    <div style={{fontSize:'0.8rem', color:'#94a3b8', display:'flex', gap:'15px', flexWrap: 'wrap'}}>
                                        <span>📍 {t.location}</span>
                                        <span>📅 {t.desired_date}</span>
                                        
                                        {isStaff && (
                                            <>
                                                <span style={{color: '#facc15', fontWeight: 'bold'}}>
                                                    🏢 {t.company_name || 'Unknown Company'}
                                                </span>
                                                <span style={{color: '#60a5fa'}}>
                                                    👤 {t.submitted_by_name || 'Unknown User'}
                                                </span>
                                            </>
                                        )}
                                    </div>
                                    {/* -------------------------------------------------- */}

                                    {/* STAFF ACTIONS */}
                                    {isStaff && t.status !== 'COMPLETED' && (
                                        <div style={{marginTop: '10px', display: 'flex', gap: '10px'}}>
                                            {t.status === 'PENDING' && (
                                                <button onClick={() => handleStatusUpdate(t.id, 'APPROVED')} className="btn-primary" style={{padding: '5px 10px', fontSize: '0.8rem'}}>
                                                    Approve
                                                </button>
                                            )}
                                            <button onClick={() => handleStatusUpdate(t.id, 'COMPLETED')} className="btn-success" style={{padding: '5px 10px', fontSize: '0.8rem'}}>
                                                Mark Complete
                                            </button>
                                        </div>
                                    )}
                                </div>
                            ))}
                        </div>
                    )}
                </div>

                {/* --- RIGHT: NEW TICKET FORM (Contractors Only) --- */}
                {!isStaff && (
                    <div className="card" style={{height: 'fit-content', borderTop: '4px solid #f472b6'}}>
                        <h3 style={{marginTop:0, color: '#f472b6'}}>➕ New Request</h3>
                        <form onSubmit={handleSubmit}>
                            <label style={{display:'block', marginBottom:'5px', fontSize:'0.9rem'}}>Request Type</label>
                            <select 
                                value={newTicket.request_type}
                                onChange={e => setNewTicket({...newTicket, request_type: e.target.value})}
                                style={{width:'100%', padding:'8px', marginBottom:'10px', background:'#334155', color:'white', border:'none'}}
                            >
                                <option value="LIFT_SHIFT">Lift & Shift</option>
                                <option value="ISOLATION">Energy Isolation</option>
                                <option value="DROP">Power Drop</option>
                                <option value="OTHER">Other</option>
                            </select>

                            <label style={{display:'block', marginBottom:'5px', fontSize:'0.9rem'}}>Description</label>
                            <textarea 
                                value={newTicket.description}
                                onChange={e => setNewTicket({...newTicket, description: e.target.value})}
                                placeholder="What do you need?"
                                style={{width:'93%', padding:'8px', marginBottom:'10px', background:'#334155', color:'white', border:'none'}}
                                required
                            />

                            <label style={{display:'block', marginBottom:'5px', fontSize:'0.9rem'}}>Location</label>
                            <input 
                                type="text"
                                value={newTicket.location}
                                onChange={e => setNewTicket({...newTicket, location: e.target.value})}
                                placeholder="e.g. Zone B, Room 4"
                                style={{width:'93%', padding:'8px', marginBottom:'10px', background:'#334155', color:'white', border:'none'}}
                                required
                            />

                            <label style={{display:'block', marginBottom:'5px', fontSize:'0.9rem'}}>Date Required</label>
                            <input 
                                type="date"
                                value={newTicket.desired_date}
                                onChange={e => setNewTicket({...newTicket, desired_date: e.target.value})}
                                style={{width:'93%', padding:'8px', marginBottom:'15px', background:'#334155', color:'white', border:'none'}}
                                required
                            />

                            <button type="submit" className="btn-primary" style={{width:'100%'}}>Submit Request</button>
                        </form>
                    </div>
                )}
            </div>
        </div>
    );
};

export default SupportTickets;